import MobileEventCard from "./MobileEventCard";

export default function MobileFeaturedEventCardCarousel({ events }) {
    const isActive = "carousel-item active";
    const nActive = "carousel-item";

    return (
        <div id="eventCardCarousel" className="carousel slide">
            <div className="carousel-inner">
                    {events.map((event, i) => {
                        return (
                        <div className={i===0 ? isActive:nActive} key={event.id}>
                            <MobileEventCard key={event.id} name={event.name} dateTime={event.start_time} categories={event.categories} venue={event.venues[0]} event={event}/>
                        </div>)})}
                <button className="carousel-control-prev" type="button" data-bs-target="#eventCardCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#eventCardCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    )
}
  
